/* eslint-disable */
import React, { useState ,useEffect} from "react";
import { useNavigate,useSearchParams } from "react-router-dom";
import logo from "../../assets/Logo.png"
import { Stack, Grid, TextField } from "@mui/material";
import Container from "../UI/Container";
import axios from "../../api";
import { Button } from "@mui/material";
import { useTranslation } from "react-i18next";
import CheckIcon from '@mui/icons-material/Check';
// import UnstyledSwitches from "../UI/switchPro";
import { usePopUpContext } from "../../Context/PopupMessage";
const Login = () => {
  const [searchParams] = useSearchParams();
  const { setPopupMessage, setLoading } = usePopUpContext();
  const { t } = useTranslation();
  let esvUsrTyp = searchParams.get("type");
  useEffect(() => {
    console.log(esvUsrTyp)
  esvUsrTyp = searchParams.get("type");
},[searchParams]);
  const navigate = useNavigate();
  const [data, setData] = useState({ prsMd:"L",esvLgnId: "", esvLgnPwd: '' });


  const handleChange = (value, target) => {

    setData({
      ...data,
      [target]: value,


    });

  }
  const handleSubmit = (event) => {
     event.preventDefault();
    setLoading(true)
    let type = esvUsrTyp
    if(esvUsrTyp == 'Internal' || esvUsrTyp ==  'I'){
      type ="I"
    }else if(esvUsrTyp == 'External' || esvUsrTyp ==  'E'){
      type ="E"
    }
    let url = "/loginvalidation"
    data["esvUsrTyp"]=type //todo E/I
    // navigate("/Dashboard")

    axios.post(url, data)


      .then(res => {
        setLoading(false)
        let response =res.data.output
        if(response.rtnSts===0){
          console.log(response)
          localStorage.setItem("email", response.email1)
          localStorage.setItem("token", response.token)
          localStorage.setItem("name", response.dispNm)
          localStorage.setItem("type", type)
          localStorage.setItem("usrLgnId", data.esvLgnId)
          localStorage.setItem("updOid", response.oid)
          localStorage.setItem("nRawtSeqN", 0)
          
          localStorage.setItem("detail", JSON.stringify(response))
          navigate("/Dashboard") 
        }
       
      })
      .catch(e => {
       
        setLoading(false)
        setPopupMessage({ state: true, type: "error", message: e.response? e.response.data.Message:e.message  })
      }
      )
  }
  const styles = {

    logo: {
      marginLeft: "5px",
      backgroundPosition: "center",
      backgroundImage: `url(${logo})`,
      backgroundRepeat: " no-repeat"
    },
  };


  return (


    <Container className="ixMainLayout" id="mainCintainer"  >

      <Stack direction="row"
        sx={{

          background: "white",
          position: 'absolute',
          top: '40%',
          left: '50%',
          transform: 'translate(-50%, -50%)',

          height: 180,

        }} >


        <Container sx={{ width: 250 }} style={styles.logo}>
          <></>
        </Container>
        <form   onSubmit={(e) => handleSubmit(e)}>
        <Grid width={400} container spacing={2}
          paddingTop={6}
        >


          <Grid item xs={3} >
            {t("User name")}
          </Grid>
          <Grid item xs={9}>
            <TextField
                autoComplete="username" 
              value={data.esvLgnId}
              onChange={(event) => handleChange(event.target.value, "esvLgnId")}



            />
          </Grid>

          <Grid item xs={3} >
            {t("lbl-pwd")}
          </Grid>
          <Grid item xs={9}>
            <TextField
              autoComplete="new-password"
              type="password"
              value={data.esvLgnPwd}
              onChange={(event) => handleChange(event.target.value, "esvLgnPwd")}




            />
          </Grid>
          <Grid item xs={9} textAlign="end"  > <Button type="submit" styletype="icon"> <CheckIcon />  </Button></Grid>
        </Grid>
        </form>










      </Stack>


    </Container>


  );
}

export default Login;